import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

const tiempoRelativo = desde => {
  if (!desde) return ""
  const ms = Date.now() - desde
  const seg = Math.floor(ms / 1000)
  if (seg < 10) return "hace un momento"
  if (seg < 60) return `hace ${seg} s`
  const min = Math.floor(seg / 60)
  if (min < 60) return `hace ${min} min`
  const h = Math.floor(min / 60)
  if (h < 24) return `hace ${h} h`
  const d = Math.floor(h / 24)
  return `hace ${d} d`
}

const UltimaActualizacion = ({ timestamp }) => {
  const [, tick] = useState(0)

  useEffect(() => {
    if (!timestamp) return
    const interval = setInterval(() => tick(t => t + 1), 30_000)
    return () => clearInterval(interval)
  }, [timestamp])

  if (!timestamp) return null

  const fecha = new Date(timestamp)

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: "#64748b",
      }}
      title={fecha.toLocaleString("es-CO")}
    >
      <i className="mdi mdi-clock-outline" />
      Actualizado {tiempoRelativo(timestamp)}
    </span>
  )
}

UltimaActualizacion.propTypes = {
  timestamp: PropTypes.number,
}

export default UltimaActualizacion
